export default __webpack_public_path__ + "static/media/PCMExplorer.e198c40d.jpg";